import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import toast from 'react-hot-toast';
import { UserPlus } from 'lucide-react';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    employee_code: '',
    email: '',
    password: '',
    password_confirm: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {
      await register(form);
      toast.success('Cuenta creada correctamente.');
      navigate('/');
    } catch (err) {
      const data = err.response?.data;
      if (data && typeof data === 'object') {
        // Map field errors
        const fieldErrors = {};
        Object.keys(data).forEach(key => {
          if (Array.isArray(data[key])) {
            fieldErrors[key] = data[key].join(' ');
          } else if (typeof data[key] === 'string') {
            fieldErrors[key] = data[key];
          }
        });
        setErrors(fieldErrors);
      } else {
        toast.error('Error al crear la cuenta.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card animate-in">
        <h2>Crear cuenta</h2>
        <p>Necesitas tu código de empleado y correo registrado</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Código de empleado</label>
            <input
              className="form-input"
              name="employee_code"
              value={form.employee_code}
              onChange={handleChange}
              placeholder="Ej: 1194-15"
              required
            />
            {errors.employee_code && <div className="form-error">{errors.employee_code}</div>}
          </div>

          <div className="form-group">
            <label>Correo electrónico</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
            {errors.email && <div className="form-error">{errors.email}</div>}
          </div>

          <div className="form-group">
            <label>Contraseña (mín. 8 caracteres)</label>
            <input
              className="form-input"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              minLength={8}
              required
            />
            {errors.password && <div className="form-error">{errors.password}</div>}
          </div>

          <div className="form-group">
            <label>Confirmar contraseña</label>
            <input
              className="form-input"
              type="password"
              name="password_confirm"
              value={form.password_confirm}
              onChange={handleChange}
              required
            />
            {errors.password_confirm && <div className="form-error">{errors.password_confirm}</div>}
          </div>

          <button type="submit" className="btn btn--primary btn--lg" disabled={loading} style={{ width: '100%' }}>
            <UserPlus size={16} />
            {loading ? 'Creando cuenta...' : 'Registrarme'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: '0.85rem' }}>
          <p>¿Ya tienes cuenta? <Link to="/login">Iniciar sesión</Link></p>
        </div>
      </div>
    </div>
  );
}
